import { render, staticRenderFns } from "./ChequePage.vue?vue&type=template&id=2748eff6"
import script from "./ChequePage.js?vue&type=script&lang=js&external"
export * from "./ChequePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports